module.exports = {"benefits":"Benefícios","currency":"R$"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/InvoiceComplete/data.json
// module id = 2074
// module chunks = 0